<template>

    <section class="org-area account-section" v-if="loaded">
        <div class="account-container">

            <div class="alert alert-success mb-5" v-if="userDeleted">
                Admin user deleted
            </div>

            <div class="mb-5 d-flex align-items-center justify-content-between">
                <div>
                    <h1 class="m-0 h2">Organization Admins</h1>
                    <div class="mt-1 color-light-bluegray text-xsmall" v-if="loaded">{{ users.length }} total admins</div>
                    <div class="mt-1 color-light-bluegray text-xsmall" v-else>Loading admins...</div>
                </div>
            </div>

            <div class="card card-padding-table">
                <table class="table org-users-table overflow-hidden m-0">
                    <tr>
                        <th class="border-top-0 text-uppercase text-2xsmall color-light-bluegray pb-1 pt-2 pl-0">Name</th>
                        <th class="border-top-0 text-uppercase text-2xsmall color-light-bluegray pb-1 pt-2">Email</th>
                        <th class="border-top-0 text-uppercase text-2xsmall color-light-bluegray pb-1 pt-2">Created</th>
                        <th class="border-top-0 text-uppercase text-2xsmall color-light-bluegray pb-1 pt-2 pr-0 text-right">Actions</th>
                    </tr>
                    <tr v-if="loaded" v-for="user in users" v-bind:key="user.id">
                        <td class="text-small align-middle pl-0" v-bind:class="{ 'color-light-bluegray': user.invited_at && user.invite_accepted_at === null}">
                            {{ user.name }}
                            <span class="color-light-bluegray" v-if="user.id == logged_in_user.id">
                                (You)
                            </span>
                        </td>
                        <td class="text-small align-middle" v-bind:class="{ 'color-light-bluegray': user.invited_at && user.invite_accepted_at === null}" v-text="user.email"></td>
                        <td class="text-small align-middle" v-bind:class="{ 'color-light-bluegray': user.invited_at && user.invite_accepted_at === null}">
                            <template v-if="user.invited_at && user.invite_accepted_at === null">
                                Invited at {{ user.created_at | toDate }}
                            </template>
                            <template v-else>
                                {{ user.created_at | toDate }}
                            </template>
                        </td>
                        <td class="text-right align-middle pr-0">
                            <a v-bind:href="'/users/user/' + user.id" class="btn btn-mediumblue btn-sm">Edit</a>
                        </td>
                    </tr>
                    <tr v-if="loaded === false">
                        <td class="text-small align-middle" colspan="6"><div class="inline-loading"></div><div class="d-inline-block">Loading...</div></td>
                    </tr>
                    <tr v-if="loaded && users.length === 0">
                        <td class="text-small align-middle" colspan="6">No users created yet</td>
                    </tr>
                </table><!-- .table -->
            </div><!-- .employee-card -->
            <div class="mt-4">
                <template v-if="remaining_users > 0">
                    <a href="/users/user/new" class="btn btn-primary">Invite New Admin</a>
                </template>
                <span class="btn btn-primary btn-disabled disabled" v-else>Invite New Admin</span>
                <span class="color-light-bluegray text-xsmall ml-3">{{ remaining_users }} admins available</span>
            </div>

        </div><!-- .container -->

    </section><!-- .org-area -->

</template>

<script>
    import { DateTime } from "luxon";
    export default {
        props: {
            userDeleted: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                organization: null,
                logged_in_user: null,
                users: null,
                remaining_users: [],
                loaded: false,
            }
        },
        mounted() {
            var self = this;
            axios.get('/users/data')
            .then(function(response) {
                self.organization = response.data.organization;
                self.logged_in_user = response.data.user;
                self.users = response.data.users;
                self.remaining_users = response.data.remaining_users;
                self.loaded = true;
            }.bind(this)).catch(function(data) {
                console.log('error');
            });
        },
        filters: {
            toDate: function(date) {
                return DateTime.fromISO(date).toLocaleString();
            },
            toLowerCase: function(string) {
                return string.toLowerCase().trim();
            }
        },
        methods: {
            templateLink: function(template) {
                if (template.employee_signatures.length >= 1) {
                    return '/employees/' + this.employee.id + '/signature/' + template.employee_signatures[0].id;
                } else {
                    return '/employees/' + this.employee.id + '/new/' + template.id;
                }
            },
            openTemplatesModal: function() {
                if (this.templates.length === 1) {
                    window.location.href = this.templateLink(this.templates[0]);
                } else {
                    this.showTemplatesModal = true;
                }
            },
            getCircleInitials: function() {
                if (this.employee && this.employee.full_name) {
                    var names = this.employee.full_name.split(' ');
                    var initials = names[0].substring(0, 1).toUpperCase();
                    if (names.length > 1) {
                        initials += names[names.length - 1].substring(0, 1).toUpperCase();
                    }
                    return initials;
                } else if (this.employee && this.employee.email) {
                    return this.employee.email.substring(0, 1).toUpperCase();
                }
            },
            deleteEmployee: function() {
                var confirmation = confirm("Are you sure you want to delete this employee and all of their signature data permanently? They will no longer be able to recall and edit their signature from the email link we sent them earlier!");
                if (confirmation == true) {
                    var self = this;
                    axios.post('/employees/' + this.load_employee_id + '/delete')
                    .then(function(response) {
                        if (response.data.status == 'success') {
                            window.location.href = "/employees";
                        }
                    }.bind(this)).catch(function(data) {
                        console.log('error');
                    });
                }
            },
            deleteEmployeeSignature: function(employee_signature_id) {
                var confirmation = confirm("Are you sure you want to delete this employee signature permanently?");
                if (confirmation == true) {
                    var self = this;
                    axios.post('/employees/' + this.load_employee_id + '/signature/' + employee_signature_id + '/delete')
                    .then(function(response) {
                        if (response.data.status == 'success') {
                            Vue.notify({
                                group: 'bottomleftmessages',
                                title: 'Employee signature deleted!',
                                type: 'success',
                            });
                        }
                    }.bind(this)).catch(function(data) {
                        console.log('error');
                    });
                }
            }
        }
    }
</script>
